import { Component, Input, OnInit } from "@angular/core";
import { Platform } from "@ionic/angular";
import { RemoveWhiteSpacePipe } from "src/app/pipes/whitespace";
import { GlobalDataService } from "src/app/services/global-data.service";

interface ContactListItem {
  title: string;
  email: boolean;
  tel: string;
  telSanitized?: string;
}

interface ContactListInterface {
  title: string;
  items: ContactListItem[];
  content: string;
  sectionTitle?: string;
  background?: string;
}

@Component({
  selector: "app-contact-list",
  templateUrl: "./contact-list.component.html",
  styleUrls: ["./contact-list.component.scss"],
  providers: [RemoveWhiteSpacePipe],
})
export class ContactListComponent implements OnInit {
  desktop: boolean = false;
  items: ContactListItem[];

  @Input() node: ContactListInterface;
  @Input() withSubject: boolean = false;

  constructor(
    private platform: Platform,
    private removeWhiteSpace: RemoveWhiteSpacePipe,
    private globalData: GlobalDataService
  ) {
    this.platform.ready().then(() => {
      this.desktop = this.platform.is("desktop") || (typeof window !== "undefined" && window.innerWidth > 1200);
    });

    this.platform.resize.subscribe(async () => {
      this.desktop = this.platform.is("desktop") || (typeof window !== "undefined" && window.innerWidth > 1200);
    });

    this.globalData.dataChange.subscribe((value) => {
      this.selectContactList(value);
    });
  }

  setContactList(contactList) {
    this.items = contactList.map((item) => {
      const telStart = item.contactNumber.charAt(0);
      const telSanitized =
        telStart === "0"
          ? "+27" + item.contactNumber.substring(1)
          : telStart === "27"
          ? "+" + item.contactNumber
          : item.contactNumber;
      return {
        email:
          item.email && item.email.indexOf("subject") < 0 && this.withSubject
            ? item.email +
              "?subject=" +
              encodeURIComponent(item.department + " Enquiry from Website")
            : item.email,
        title: item.department,
        tel: item.contactNumber,
        telSanitized: this.removeWhiteSpace.transform(telSanitized),
      };
    });
  }

  selectContactList(mallData) {
    if (
      this.node.title === "Visitor Information Centre" &&
      mallData.contactInformation?.visitorInformation
    ) {
      // Visitor Information
      this.setContactList(mallData.contactInformation.visitorInformation);
    } else if (mallData.contactInformation?.centreManagement) {
      // Centre Management
      this.setContactList(mallData.contactInformation.centreManagement);
    }
  }

  ngOnInit() {
    const initialMallData = this.globalData.getGlobalData();
    if (initialMallData) this.selectContactList(initialMallData);
  }
}
